import Aos from 'aos';
import React from 'react'
import { useEffect } from 'react';
import DiscoverSection from './components/DiscoverSection';
import DiscoverSection2 from './components/DiscoverSection2';
import BestCollection from './components/BestCollection';
import ShopByShape from './components/ShopByShape';
import WhatPeopleSay from './components/WhatPeopleSay';
import DiscoverMore from './components/DiscoverMore';
import MainBanner from './components/Banner';
import CategorySection from './components/CategorySection';
import SocialMedia from './components/SocialMedia';

const TokyoHome = () => {

    useEffect(() => {
        Aos.init({
        duration : 1000,
        // disable: 'mobile'
        });
    }, []);

    return ( 
        <div className='TokyoThemeHome'>
            {/* <MainBanner /> */}
            <CategorySection />
            <DiscoverSection />
            <DiscoverSection2 />
            <BestCollection />
            <ShopByShape />
            <WhatPeopleSay />
            <DiscoverMore />
            <SocialMedia />
        </div>
    )
}

export default TokyoHome